import { render, staticRenderFns } from "./service-tabs.vue?vue&type=template&id=522d7109&scoped=true&"
import script from "./service-tabs.vue?vue&type=script&lang=js&"
export * from "./service-tabs.vue?vue&type=script&lang=js&"
import style0 from "./service-tabs.vue?vue&type=style&index=0&id=522d7109&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d7109",
  null
  
)

export default component.exports